import { AuthProvider } from 'context/AuthContext/AuthContext';
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
// import { ReactQueryDevtools } from 'react-query-devtools';
import { ToastContainer } from 'react-toastify';
import AppRoutes from './AppRoutes';
import MuiProvider from './common/provider';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <MuiProvider>
        <AuthProvider>
          <AppRoutes />
          <ToastContainer
            position='top-right'
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </AuthProvider>
      </MuiProvider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
}

export default App;
